let uploadedCoverFile = [];
let uploadedCoverFile2 = [];
let cover_post_list = '';
let coverInchToPx = 300;
let coverCmToPx = 120;
let cover_picker;
var albumSpreads = parseInt($("select#SingleOptionSelector-0").find("option:selected").text());   
if( albumSpreads == 5) { var albumCoverWidthPx = 3646; }
if( albumSpreads == 10) { var albumCoverWidthPx = 3694; }
var albumCoverHeightPx = 1800;


/*
var $n = jQuery.noConflict();
$n("body").on('change', '.dd_1045850_426629', function(e){
  alert('jest:');
});  
*/


//var $ = jQuery.noConflict();
$(document).ready(function() { 

 

 
	$("body").on('change', '.mango-cover-uploader-wrapper #step-2-confirmation input[type="checkbox"]', function(e){
		var checked = $(this).prop('checked');
		if(checked == true) {
			$(".mango-cover-uploader-wrapper #go-to-finish").show();
		} else {	
			$(".mango-cover-uploader-wrapper #go-to-finish").hide();
		}   
    });  
  	$(".mango-cover-uploader-wrapper #go-to-finish").click(function(){
		finishCoverUploader();
    });  
    $("body").on('click', ".mango-cover-uploader-wrapper button.close", function(e){
		closeCoverUploader();    
    });
    $("body").on('click', ".mango-cover-uploader-wrapper button.close2", function(e){
		closeCoverPreview();    
    });  
    $("body").on('click', ".mango-cover-uploader-wrapper #step-2-cancel", function(e){
		closeCoverUploader();
    });  

    $("select#SingleOptionSelector-0").on('change', function() {
        albumSpreads = parseInt( $(this).find("option:selected").text() );    
        if( albumSpreads == 5) { albumCoverWidthPx = 3646; }
        if( albumSpreads == 10) { albumCoverWidthPx = 3694; }
    });  

    $("#file-cover-upload-show-btn").click(function(){
        $( "#mango-cover-uploader-preview-order .item" ).remove();        
        $( "#mango-cover-uploader-preview-slider .item" ).remove();  
        $( "#mango-cover-uploader-preview-slider2 .item" ).remove();        
        $(".label-album-size").text(albumCoverWidthPx + 'x' + albumCoverHeightPx);      
     
		const cover_filestack_client = filestack.init('AbkDGv2FYSHi0mxqhYMgQz'); 
        const cover_options = {
        	displayMode: 'inline',
        	container: '#coverdroppane',    
  			accept: ["image/jpeg", "image/jpg"],          
			fromSources: ["local_file_system","googledrive","onedrive"],
			exposeOriginalFile: true,          
          	maxFiles: 1,
          	minFiles: 1,          
            transformations: {
               crop: {
                    aspectRatio: albumCoverWidthPx/albumCoverHeightPx,
                    force: true
                },
           		circle: false,
           	 	rotate: false
            },
            customText: {                     
              'Filter': 'Filtruj',              
              'Upload': 'Prześlij',
              'Add': 'Dodaj jeszcze',  
              'Images': 'Lista obrazów',              
              'more file': 'plik',
              'more files': 'plików',              
      'Upload more': 'Wybierz więcej',
              'Deselect All': 'Odznacz wszystkie',
              'or Drag and Drop, Copy and Paste Files': 'lub przeciągnij i upuść, skopiuj i wklej pliki',
              'Select Files to Upload': 'Wybierz pliki do przesłania',
      'Our file upload limit is {maxFiles} {filesText}': 'Liczba plików projektu nie odpowiada liczbie rozkładówek. Zamknij to okno i wybierz poprawną ilość rozkładówek na karcie produktu.',
          },
            onFileUploadFinished: function(file) {
//		console.log(file);              
				uploadedCoverFile.push(file["url"]);
				uploadedCoverFile2.push(file["filename"] +'^'+file["handle"]);          
            },          
       	 	onUploadDone: function(){
              	uploadedCoverFile2.sort();
   				uploadCoverFinished(uploadedCoverFile2);
              	// send tokens to helper
              	$.each( uploadedCoverFile2, function( key, value ) {
					post_list = post_list + value +',';
				});
              	var post_list_data = { 
                  	hash : $( "#mango_post_list_data_hash" ).val(),
                    files : post_list,
                  	source : 'snapalbums'
                };
                $.ajax({
					type: "POST",
					url: "https://filestack.qtalbums.ovh/token_to_db.php",
					headers: { 'Content-Type': 'application/x-www-form-urlencoded'},                  
					data: post_list_data,
					success: function(msg){
					console.log(msg);  
                 }
				});      
              	// end sending
  			},      
          	//onFileSelected: checkCoverImgSize,  
          	onClose: function(){
            },      
            uploadConfig: {
				tags: {
					"foo": "bar"
				},

			},   
        };
      	cover_picker = cover_filestack_client.picker(cover_options);
      
		$(".mango-cover-uploader-wrapper").show();
		$("#mango-cover-uploader-modal").show();
      	$("#mango-cover-uploader-step-1").show();
		$("#mango-cover-uploader-step-2").hide();            
		cover_picker.open();  
		window.scrollTo(0, 0);         
    });
  

    function closeCoverUploader(){
      $(".mango-cover-uploader-wrapper").hide();
      $("#mango-cover-uploader-modal").hide();
      $("#mango-cover-uploader-step-1").hide();            
      $("#mango-cover-uploader-step-2").hide();     
      $("#mango-cover-uploader-step-3").hide();       
      $("#mango-cover-uploader-files").val('');
      $("#mango-cover-uploader-files-names").val('');        
      	cover_picker.close();      
       uploadedCoverFile = [];
       uploadedCoverFile2 = [];      

        $( "#mango-cover-uploader-preview-order .item" ).remove();        
        $( "#mango-cover-uploader-preview-slider .item" ).remove();  
        $( "#mango-cover-uploader-preview-slider2 .item" ).remove();        
    }
    function closeCoverPreview(){
		$(".mango-cover-uploader-wrapper2").hide();
		$("#mango-cover-uploader-modal2").hide();
		$("#mango-cover-uploader-step-4").hide();
    }  
    function finishCoverUploader(){
		$(".mango-cover-uploader-wrapper").hide();
		$("#mango-cover-uploader-modal").hide();
		$("#mango-cover-uploader-step-1").hide();            
      	$("#mango-cover-uploader-step-2").hide();       
		$("#file-cover-upload-show-btn").hide();    
		$("#file-cover-preview").show();        
      	cover_picker.close();
 uploadedCoverFile = [];
 uploadedCoverFile2 = [];   
   
      	$( "#mango-cover-uploader-preview-order .item" ).remove();        
        $( "#mango-cover-uploader-preview-slider .item" ).remove();       
		$("#go-to-finish").hide();       
        $("#message-no-uploader-files").hide();         
    }
  
    function uploadCoverFinished(upfiles){
//		console.log(upfiles);
		$("#mango-cover-uploader-step-1").hide();            
      	$("#mango-cover-uploader-step-2").show();                   
        //var albumSpreads = parseInt($("select#SingleOptionSelector-0").find(":selected").text());    
        $.each( upfiles, function( key, value ) {
            var temp_array = value.split('^');
            var filename = temp_array[0];              
            var handle = temp_array[1];            
            $( "#mango-cover-uploader-preview" ).append( '<img src="https://cdn.filestackcontent.com/resize=width:1800/' + handle + '" alt="" />');              		
            $( "#mango-cover-uploader-file" ).val( $( "#mango-cover-uploader-file" ).val() +  handle + ';' );       
            $( "#file-cover-preview  " ).append( '<img src="https://cdn.filestackcontent.com/resize=width:900/' + handle + '" alt="" style="width:100%;height:auto;"/>');        
            
            var image_width = $( "#mango-cover-uploader-preview img" ).width();
            var spine_width = (image_width/albumCoverWidthPx) * (albumCoverWidthPx-3600);
            $( "#mango-cover-uploader-preview" ).append( '<div class="mango-cover-uploader-preview-line" style="transform:translateX(-'+ Math.round((spine_width/2)+1) +'px)"><div/>');  
            $( "#mango-cover-uploader-preview" ).append( '<div class="mango-cover-uploader-preview-line" style="transform:translateX('+ Math.round((spine_width/2)+1) +'px)"><div/>');     


          
          // recalculate after window resize
        });
    }
  
    function checkCoverImgSize(thisfile) {
        return new Promise(function (resolve, reject) {
          const minWidth = albumCoverWidthPx * 1;
          const minHeight = albumCoverHeightPx * 1;
          const blob = thisfile.originalFile;
          const url = window.URL.createObjectURL(blob);
          const img = new Image();
          img.src = url;

          img.onload = function () {
            window.URL.revokeObjectURL(url);
            //alert( this.naturalWidth +'---'+this.naturalHeight);
            if (this.naturalWidth < minWidth) {
              reject('Image quality ('+thisfile.filename+') is to poor (width). Minimal image dimentions are ' + minWidth + 'x' + minHeight + 'px');
              cover_picker.cancel();    
            }
            else if (this.naturalHeight < minHeight) {
              reject('Image quality ('+thisfile.filename+') is to poor. Minimal image dimentions are  ' + minWidth + 'x' + minHeight + 'px');
            }
            var ratio_natural = this.naturalWidth / this.naturalHeight;
            var ratio = minWidth/minHeight;            
            var ratio_min = ((minWidth/minHeight) - 0.01);
            var ratio_max = ((minWidth/minHeight) + 0.01);  
             
            if ( (ratio_natural.toFixed(2) < ratio_min.toFixed(2)) || (ratio_natural.toFixed(2) > ratio_max.toFixed(2)) ) {
              reject('WRONG DESIGN DIMENSIONS. You have uploaded '+this.naturalWidth+'x'+this.naturalHeight+'px while we need '+minWidth+'x'+minHeight+'px or bigger but with the same proportions.');
            }
            resolve();
          }
        });
    }






});

